<mat-dialog-content class="container">
  <h2 mat-dialog-title>{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.ADD_HEADING' | translate }}</h2>
  <ng-container *ngIf="variables$ | async as variables; else empty">
    <EXP__glxy-wrap>
      <mat-form-field>
        <mat-label>{{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.CATEGORY' | translate }}</mat-label>
        <mat-select required [(value)]="chosenCategory" (selectionChange)="handleCategoryChange()">
          <mat-option *ngFor="let mainItem of variables" [value]="mainItem">
            {{ mainItem.textKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </EXP__glxy-wrap>
    <ng-container *ngIf="chosenCategory !== null">
      <EXP__glxy-wrap>
        <mat-form-field>
          <mat-label>
            {{ chosenCategory.textKey | translate }}
          </mat-label>
          <mat-select required [(value)]="chosenParam" (selectionChange)="handleParamChange()">
            <mat-option *ngFor="let subParam of chosenCategory.subItems" [value]="subParam">
              {{ subParam.displayName | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </EXP__glxy-wrap>
    </ng-container>
    <ng-container
      *ngIf="chosenCategory !== null && chosenParam !== null && chosenCategory?.options?.nestedDynamicSelector"
    >
      <ng-container *ngIf="chosenDynamicParam$ | async as dynamicValues; else loading">
        <EXP__glxy-wrap>
          <mat-form-field>
            <mat-label>
              {{ chosenParam.displayName | translate }}
            </mat-label>
            <mat-select required [(value)]="chosenParamDetails">
              <mat-option *ngFor="let v of dynamicValues" [value]="v.value">
                {{ v.title | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </EXP__glxy-wrap>
      </ng-container>
      <ng-template #loading>
        <div class="stencil-shimmer"></div>
      </ng-template>
    </ng-container>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <div>
    <button mat-stroked-button (click)="close()">
      {{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.CANCEL_BUTTON' | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="add()"
      [disabled]="
        chosenParam === null || (chosenCategory?.options?.nestedDynamicSelector === true && chosenParamDetails === null)
      "
    >
      {{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.ADD_BUTTON' | translate }}
    </button>
  </div>
</mat-dialog-actions>

<ng-template #empty>
  <glxy-empty-state size="small">
    <glxy-empty-state-title>
      {{ 'EMAIL_BUILDER.DYNAMIC_COMPONENT_DIALOG.NO_OPTIONS' | translate }}
    </glxy-empty-state-title>
  </glxy-empty-state>
</ng-template>
